export default __webpack_public_path__ + "static/media/icon_4_on.fbb92973.png";